import Vue from "vue";
import urlApi from "../router/urlApi";

let optionsToast = {
    theme: "none",
    position: "top-left",
    className: "vuestic-toast",
    iconPack: "fontawesome",
    fullWidth: false,
    duration: 3000,
    icon: "fa-warning",
};

export default {
    hex2rgb(hex, opacity) {
        hex = (hex + "").trim();

        let rgb = null;
        let match = hex.match(/^#?(([0-9a-zA-Z]{3}){1,3})$/);

        if (!match) {
            return null;
        }

        rgb = {};

        hex = match[1];

        if (hex.length === 6) {
            rgb.r = parseInt(hex.substring(0, 2), 16);
            rgb.g = parseInt(hex.substring(2, 4), 16);
            rgb.b = parseInt(hex.substring(4, 6), 16);
        } else if (hex.length === 3) {
            rgb.r = parseInt(hex.substring(0, 1) + hex.substring(0, 1), 16);
            rgb.g = parseInt(hex.substring(1, 2) + hex.substring(1, 2), 16);
            rgb.b = parseInt(hex.substring(2, 3) + hex.substring(2, 3), 16);
        }

        rgb.css = "rgb" + (opacity ? "a" : "") + "(";
        rgb.css += rgb.r + "," + rgb.g + "," + rgb.b;
        rgb.css += (opacity ? "," + opacity : "") + ")";

        return rgb;
    },

    generatePDFTurmas(idTurma, entity, extension, title) {
        var url = urlApi + entity + "/pdf/" + idTurma;
        Vue.http
            .get(url)
            .then(function (response) {
                console.log(response);
                var byteCharacters = atob(response.data.dados);
                var byteNumbers = new Array(byteCharacters.length);

                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);
                var blob = new Blob([byteArray], { type: "application/pdf" });

                var link = document.createElement("a");
                link.setAttribute("href", URL.createObjectURL(blob));
                link.setAttribute("download", title + ".pdf");
                document.body.append(link);
                link.click();
                link.remove();
                // in case the Blob uses a lot of memory
                window.addEventListener(
                    "focus",
                    (e) => URL.revokeObjectURL(link.href),
                    { once: true }
                );
            })
            .catch((erro) => {
                Vue.toasted.show(erro.body.dados, optionsToast);
                // console.log(erro.body.dados)
            });
    },

    generatePDF(entity, ini, end, aulaFlag = false) {
        var url = urlApi + "/" + entity + "/pdf/" + ini + "/" + end;
        if (aulaFlag) url = url.concat("/true");

        Vue.http.get(url).then(function (response) {
            var byteCharacters = atob(response.data.dados);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var blob = new Blob([byteArray], { type: "application/pdf" });

            // window.open(URL.createObjectURL(blob));

            var link = document.createElement("a");
            link.setAttribute("href", URL.createObjectURL(blob));
            link.setAttribute("download", entity + ".pdf");
            document.body.append(link);
            link.click();
            link.remove();
            // in case the Blob uses a lot of memory
            window.addEventListener(
                "focus",
                (e) => URL.revokeObjectURL(link.href),
                { once: true }
            );
        });
    },

    generateTXTorXLSX(entity, ext, ini, end, aulaFlag = false) {
        let csv = "data:text/csv;charset=utf-8,";

        var url = urlApi + "/" + entity + "/xlsx/" + ini + "/" + end;
        if (aulaFlag) url = url.concat("/true");

        Vue.http.get(url).then(function (response) {
            csv += response.data.dados;
            var link = document.createElement("a");
            link.setAttribute("href", encodeURI(csv));
            link.setAttribute("download", entity + "." + ext);
            document.body.append(link);
            link.click();
            link.remove();
        });
    },

    formatDate(value, noTime = false, secs = false) {
        if (value != null) {
            var t = value.split(/[- :]/);

            // Apply each element to the Date function
            if (noTime) {
                var date = new Date(new Date(t[0], t[1] - 1, t[2]));
            } else {
                var date = new Date(
                    new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5])
                );
            }

            // var date = new Date(value)

            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            var hh = date.getHours();
            var mn = date.getMinutes();
            var sc = date.getSeconds();

            date = "";

            if (!noTime) {
                if (hh) {
                    if (hh < 10) {
                        hh = "0" + hh;
                    }
                    if (mn < 10) {
                        mn = "0" + mn;
                    }
                    date += `${hh}:${mn}`;
                    if (secs) {
                        if (sc < 10) {
                            sc = "0" + sc;
                        }
                        date += `:${sc}`;
                    }
                }
            }

            if (dd < 10) {
                dd = "0" + dd;
            }
            if (mm < 10) {
                mm = "0" + mm;
            }
            date += ` ${dd}/${mm}/${yyyy}`;

            return date;
        } else {
            return false;
        }
    },

    cpfMask(cpf) {
        cpf = cpf.replace(/\D/g, "");

        let formattedCPF =
            cpf.slice(0, 3) +
            "." +
            cpf.slice(3, 6) +
            "." +
            cpf.slice(6, 9) +
            "-**";

        return formattedCPF;
    },

    formatOnlyDate(dateString) {
        if (!dateString) {
            return "-";
        }

        const [year, month, day] = dateString.split("T")[0].split("-");
        return `${day}/${month}/${year}`;
    },

    formatarCPF(cpf) {
        if (cpf) {
            cpf = cpf.replace(/\D/g, "");

            if (cpf.length !== 11) {
                throw new Error("CPF deve ter 11 dígitos.");
            }

            return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(
                6,
                9
            )}-${cpf.slice(9)}`;
        }

        return "-";
    },

    formatarCNPJ(cnpj) {
        if (cnpj) {
            cnpj = cnpj.replace(/\D/g, "");

            if (cnpj.length !== 14) {
                throw new Error("CNPJ deve ter 14 dígitos.");
            }

            return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(
                5,
                8
            )}/${cnpj.slice(8, 12)}-${cnpj.slice(12)}`;
        }

        return "-";
    },

    formatarValor(valor, locale = "pt-BR", currency = "BRL") {
        if (!valor) {
            valor = 0;
        }

        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency,
        }).format(valor);
    },

    sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    },
};
